module.exports = ".general-info-title {\n  font-size: 25px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n\n.general-info .label {\n  color: #000;\n  font-size: 15px;\n  margin-bottom: 7px;\n  display: inline-block;\n}\n\n.general-info .value {\n  color: #666;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.label {\n  line-height: 1;\n  font-weight: bold;\n  padding: 0.2em 0.6em 0.3em;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/view-payment-term/view-payment-term.component.css
// module id = ./src/app/main-settings/view-payment-term/view-payment-term.component.css
// module chunks = main